export default {
  addOns: 'Dodatki',
  availability: 'Dostępność',
  availabilityDaySelector: 'Wybór daty dostępności',
  unavailable: 'Niedostępne',
  person: 'osoba',
  people: 'osoby',
  reserveNow: 'Zarezerwuj teraz',
  selectTime: 'Wybierz godzinę',
  select: 'Wybierz',
  reserve: 'Zarezerwuj',
  time: 'Czas',
  tier: 'Poziom',
  questions: 'Pytania',
  addToCart: 'Dodaj do koszyka',
  checkout: 'Realizacja zamówienia',
  total: 'Suma',
  whatsIncluded: 'Co jest w cenie',
  showMore: 'Pokaż więcej',
  showLess: 'Pokaż mniej',
  session: 'Sesja',
  viewDetails: 'Zobacz szczegóły',
  findAvailability: 'Znajdź dostępność',
  loading: 'Ładowanie',
  capacity: 'Pojemność',
  noAvailableSessionsOnThisDate: 'Brak dostępnych sesji w tym dniu',
  noGroupAvailableOnThisDateAndTime:
    'Brak dostępnych {{groupTitle}} w tym dniu i o tej godzinie',
  noCollectionFound: 'Nie znaleziono kolekcji!',
  noResourceGroupFound: 'Nie znaleziono grupy zasobów!',
  noData: 'Brak danych!',
  continue: 'Kontynuuj',
  night: 'noc',
  nights: 'noce',
  noAvailableSessionsForSelectedDates:
    'Niektóre daty w Twoim wyborze nie mają dostępnych sesji. Proszę wybrać inne daty.',
  from: 'od',
  dateRangeSelector: 'Wybór zakresu dat',
  priceTierRadioGroup: 'Wybór poziomu ceny',
  startTime: 'Godzina rozpoczęcia',
  duration: 'Czas trwania',
  lengthOfStay: 'Długość pobytu',
  startDate: 'Data rozpoczęcia',
  endDate: 'Data zakończenia',
  selectDates: 'Wybierz daty',
  more: 'Więcej',
  selectStartTime: 'Wybierz godzinę rozpoczęcia',
  endTime: 'Godzina zakończenia',
  selectEndTime: 'Wybierz godzinę zakończenia',
  morning: 'Rano',
  afternoon: 'Popołudnie',
  save: 'Zapisz',
  selectDuration: 'Wybierz czas trwania',
  forLength: 'na {{length}}',
  moreDates: '{{count}} więcej',
  addDate: 'Dodaj datę',
  start: 'Początek',
  end: 'Koniec',
  pickupFrom: 'Odbiór od',
  returnBy: 'Zwrot do',
  day: 'dzień',
  days: 'dni',
  hour: 'godzina',
  hours: 'godzin',
};
